import Client from '@datacamp/prometheus-aggregator-client';
import config from '../../config';
let client = null;
const prometheusClient = environment => {
  if (client === null) {
    client = new Client({
      serverRoot: config(environment).urls.PROMETHEUS_AGGREGATOR_URL
    });
  }
  return client;
};
export default prometheusClient;